// Virtual Marketer Primeo - Frontend Constants
// Version: 1.0.0

// API Configuration - All requests go through backend
export const API_BASE_URL = import.meta.env.VITE_API_URL as string || 'http://localhost:8080/api/v1';

// Chatbot Configuration - Watt-son for Primeo Energie
export const CHATBOT_NAME = "watt-son";
export const BOT_GREETING_MESSAGE = "Hallo! Ich bin Watt-son, dein digitaler Assistent für Primeo Energie. Ich helfe dir gerne bei Produktfragen, Verfügbarkeit, Versand oder Retouren. Was kann ich für dich tun?";
export const BOT_AVATAR_URL = "https://primeo-energie.ch/assets/images/logo.png";

// Primeo Branding Colors
export const PRIMARY_COLOR = "#0066CC";
export const SECONDARY_COLOR = "#004499";

// Local Storage
export const LOCAL_STORAGE_KEY = 'primeo_energie_chat_history';
export const MAX_MESSAGES_TO_STORE = 8;

// Signals / Triggers (from backend)
export const SEARCH_REQ_REGEX_STRING = "\\[SEARCH_REQ:\\s*(\\{[\\s\\S]+?\\})\\]";
export const DISPLAY_RESULTS_REGEX_STRING = "\\[DISPLAY_RESULTS:\\s*(\\[.*?\\])\\]";

// Error Messages
export const ERROR_MESSAGES = {
    NETWORK_ERROR: "Netzwerkfehler. Bitte überprüfe deine Internetverbindung.",
    API_ERROR: "Ein Fehler ist aufgetreten. Bitte versuche es später erneut.",
    NO_API_KEY: "API nicht konfiguriert. Bitte wende dich an den Support."
};

// Chat Configuration
export const MAX_MESSAGE_LENGTH = 2000;
export const TYPING_INDICATOR_DELAY = 300;
